import React from 'react';
import { LanguagesEnum } from '../../../../config/languages';
import ActionBlock from './components/datatable/actions';

const CONFIGURATION = {};

export const Translations = {
  form_error_required: {
    [LanguagesEnum.English]: 'This is required',
    [LanguagesEnum.Greek]: 'Υποχρεωτικό πεδίο',
  },
  header: {
    [LanguagesEnum.English]: 'Identification in Other EU Countries',
    [LanguagesEnum.Greek]: 'Identification in Other EU Countries',
  },
  subtitle: {
    [LanguagesEnum.English]:
      'If another EU country has assigned you a VAT Identification number as a non-established taxable person, please list all numbers and the country that assigned each number.',
    [LanguagesEnum.Greek]:
      'If another EU country has assigned you a VAT Identification number as a non-established taxable person, please list all numbers and the country that assigned each number.',
  },
  vat_number_label: {
    [LanguagesEnum.English]: 'VAT Number',
    [LanguagesEnum.Greek]: 'Αριθμός ΦΠΑ',
  },
  issuing_country_label: {
    [LanguagesEnum.English]: 'Issuing Country',
    [LanguagesEnum.Greek]: 'Χώρα Έκδοσης',
  },
  add_header_button: {
    [LanguagesEnum.English]: 'Add Identification in other EU Countries',
    [LanguagesEnum.Greek]: 'Add Identification in other EU Countries',
  },
  add: {
    [LanguagesEnum.English]: 'Add',
    [LanguagesEnum.Greek]: 'Προσθήκη',
  },
};

export const TableColumns = (mode: 'VIEW' | 'EDIT') => {
  return [
    {
      label: '#',
      id: 'id',
      render: (rowIndex: number, cellValue: any, columnIndex: number) => (
        <React.Fragment>{cellValue}</React.Fragment>
      ),
      inData: true,
    },
    {
      label: 'VAT Number',
      id: 'vat_id_num',
      render: (rowIndex: number, cellValue: any, columnIndex: number) => (
        <React.Fragment>{cellValue}</React.Fragment>
      ),
      inData: true,
    },
    {
      label: 'Country',
      id: 'country',
      render: (rowIndex: number, cellValue: any, columnIndex: number) => (
        <React.Fragment>{cellValue}</React.Fragment>
      ),
      inData: true,
    },
    {
      label: 'Actions',
      align: 'center',
      id: 'action',
      render: (
        rowIndex: number,
        cellValue: any,
        columnIndex: number,
        data: any
      ) => <ActionBlock rowIndex={rowIndex} mode={mode} />,
      inData: false,
    },
  ];
};

export default CONFIGURATION;
